// @ts-nocheck

import React, { useLayoutEffect } from 'react';
import { Redirect, RouteComponentProps } from '@reach/router';

type PrivateRouteProps<T> = RouteComponentProps &
  T & {
    component: React.ComponentType<T>;
  };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PrivateRoutes = ({ component: Component, ...rest }: PrivateRouteProps<any>): JSX.Element => {
  useLayoutEffect(() => {
    if (!localStorage.getItem('token')) {
      localStorage.setItem('path', rest.location.pathname);
      localStorage.setItem('hash', rest.location.hash);
    }
  }, [rest]);

  return localStorage.getItem('token') ? <Component {...rest} /> : <Redirect from="" to="/login" noThrow />;
};
